/**
 * NotificationBell Component
 *
 * Self-contained sidebar bell that shows unread count badge and
 * composes with NotificationDropdown for the popover panel.
 */

import { cn } from '@/shared/utils';
import { Icon, IconKey } from '@/shared/components';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useUnreadCount } from '../hooks';
import { NotificationDropdown } from './notification-dropdown';

export function NotificationBell() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isActive = pathname === '/notifications';
  const { data } = useUnreadCount();
  const count = data?.count ?? 0;

  return (
    <NotificationDropdown open={open} onOpenChange={setOpen}>
      <button
        className={cn(
          'flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors w-full hover:cursor-pointer mt-3',
          open || isActive ? 'bg-secondary/30 text-text' : 'text-text/50 hover:text-text'
        )}
      >
        <div className='relative'>
          <Icon icon={IconKey.Bell} size={20} className={cn('transition-colors', open || isActive ? 'text-accent' : 'text-accent/50')} />
          {count > 0 && (
            <span className='absolute -top-1.5 -right-1.5 flex items-center justify-center h-4 min-w-4 px-0.5 rounded-full bg-red-500 text-white text-[10px] font-bold border-2 border-background'>
              {count > 9 ? '9+' : count}
            </span>
          )}
        </div>
        <span className='text-md'>Notifications</span>
      </button>
    </NotificationDropdown>
  );
}
